<template>
    <v-navigation-drawer v-if="authorized" app permanent width="240"
        :color="this.$vuetify.theme.dark ? '#424242' : '#FAFAFA'" :mini-variant="$vuetify.breakpoint.lgAndDown">
        <!--
        <v-list two-line class="text-center">
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ userInfo.organization_name }}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item-avatar rounded size="80" class="rounded-circle border-primary">
                <v-img :src=userInfo.photos.picture></v-img>
            </v-list-item-avatar>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ userInfo.display_name }}
                        <div class="caption font-weight-bold">
                            {{ currentUserType }}
                        </div>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ userInfo.username }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            
            <v-list-item>
                <v-list-item-content>
                    <div class="pa-3 transparent text-no-wrap rounded-pill">
                        <a class="text-decoration-none" href="/profile">
                            <v-chip color="primary" style="cursor:pointer">
                                {{ $t('MANAGE_MY_PROFILE') }}
                            </v-chip>
                        </a>
                    </div>
                </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
        </v-list>-->
        <v-list>
            <v-list-item dense>
                <v-list-item-avatar size="24" class="text-left">
                    <v-img :src=userInfo.photos.picture></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        {{ userInfo.display_name }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{ currentUserType }}
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-list dense nav shaped>
            <v-list-item :to="item.href" v-for="(item, i) in modules" :key="i" link>
                <v-tooltip bottom v-if="$vuetify.breakpoint.lgAndDown">
                    <template v-slot:activator="{ on, attrs }">
                        <v-list-item-icon v-bind="attrs" v-on="on">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                    <span>{{ item.text }}</span>
                </v-tooltip>
                <v-list-item-icon v-else>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <template v-slot:append>
            <v-list dense nav shaped>
                <v-list-item @click="logout()">
                    <v-tooltip top v-if="$vuetify.breakpoint.lgAndDown">
                        <template v-slot:activator="{ on, attrs }">
                            <v-list-item-icon v-bind="attrs" v-on="on">
                                <v-icon>mdi-logout</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ $t('SIGN_OUT') }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                        <span>{{ $t('SIGN_OUT') }}</span>
                    </v-tooltip>
                    <v-list-item-icon v-else>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t('SIGN_OUT') }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </template>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: "NavigationBar",
    props: {
        showMiniVariant: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            
        }
    },
    computed: {
        authorized() {
            return this.$store.state.authorized;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        modules() {
            return this.$store.state.metadata.modules;
        },
        currentUserType() {
            const user = this.$store.state.metadata?.userTypes?.find(user => user.type === this.$store.state.userInfo.type);
            if (user) {
                return user.name;
            } else {
                return '';
            }
        },
    },
    methods: {
        logout() {
            this.$store.dispatch('logout').finally(() => {
                localStorage.clear();
                this.$router.push('/signin');
            });
        },
    }
}
</script>

<style scoped> 
</style>

<i18n>
  {
    "en": {
      "SIGN_OUT" : "Sign Out"
    }
  }
  </i18n>